// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3nKi7","body":"styles_body__3a79h"};